"use client";
import Link from "next/link";
import { getPageVisibilityClass, LogoVariant } from "../design1/Footer";
import { FOOTER_NAV_LINKS } from "../../constants/navlink";
import React from "react";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import { useFetchValidSocialMediaLinks } from "src/app/lib/useFetcchValidSocialMediaLinks";
import { Config } from "src/types";
import { CompanyLogo } from "../design1/NavBar";
import { usePagesWithBranchQuery } from "src/app/hooks/useBranchFirst";

const FacebookIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M21.998 6.00195H18.998C17.672 6.00195 16.4002 6.52874 15.4625 7.46642C14.5248 8.4041 13.998 9.67587 13.998 11.002V14.002H10.998V18.002H13.998V26.002H17.998V18.002H20.998L21.998 14.002H17.998V11.002C17.998 10.7367 18.1034 10.4824 18.2909 10.2948C18.4785 10.1073 18.7328 10.002 18.998 10.002H21.998V6.00195Z"
        fill="white"
      />
    </svg>
  );
};
const LinkedinIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M19.334 12.666C20.6601 12.666 21.9318 13.1928 22.8695 14.1305C23.8072 15.0682 24.334 16.3399 24.334 17.666V23.4993H21.0007V17.666C21.0007 17.224 20.8251 16.8001 20.5125 16.4875C20.1999 16.1749 19.776 15.9993 19.334 15.9993C18.892 15.9993 18.468 16.1749 18.1555 16.4875C17.8429 16.8001 17.6673 17.224 17.6673 17.666V23.4993H14.334V17.666C14.334 16.3399 14.8608 15.0682 15.7985 14.1305C16.7361 13.1928 18.0079 12.666 19.334 12.666Z"
        fill="white"
      />
      <path d="M10.9993 13.5H7.66602V23.5H10.9993V13.5Z" fill="white" />
      <path
        d="M9.33268 10.9993C10.2532 10.9993 10.9993 10.2532 10.9993 9.33268C10.9993 8.41221 10.2532 7.66602 9.33268 7.66602C8.41221 7.66602 7.66602 8.41221 7.66602 9.33268C7.66602 10.2532 8.41221 10.9993 9.33268 10.9993Z"
        fill="white"
      />
    </svg>
  );
};
const InstagramIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M20.166 7.66602H11.8327C9.5315 7.66602 7.66602 9.5315 7.66602 11.8327V20.166C7.66602 22.4672 9.5315 24.3327 11.8327 24.3327H20.166C22.4672 24.3327 24.3327 22.4672 24.3327 20.166V11.8327C24.3327 9.5315 22.4672 7.66602 20.166 7.66602Z"
        fill="white"
      />
      <path
        d="M19.3337 15.4753C19.4366 16.1688 19.3181 16.8771 18.9952 17.4994C18.6723 18.1218 18.1614 18.6264 17.5351 18.9416C16.9088 19.2569 16.1991 19.3666 15.5069 19.2552C14.8147 19.1438 14.1752 18.817 13.6794 18.3212C13.1837 17.8255 12.8569 17.186 12.7455 16.4938C12.6341 15.8015 12.7438 15.0918 13.059 14.4656C13.3742 13.8393 13.8789 13.3284 14.5012 13.0055C15.1236 12.6825 15.8319 12.5641 16.5254 12.6669C17.2328 12.7718 17.8878 13.1015 18.3935 13.6072C18.8992 14.1129 19.2288 14.7678 19.3337 15.4753Z"
        stroke="var(--primary-color)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.584 11.416H20.594"
        stroke="var(--primary-color)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const TwitterIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M23.5 7H8.5C8.10218 7 7.72064 7.15804 7.43934 7.43934C7.15804 7.72064 7 8.10218 7 8.5V23.5C7 23.8978 7.15804 24.2794 7.43934 24.5607C7.72064 24.842 8.10218 25 8.5 25H23.5C23.8978 25 24.2794 24.842 24.5607 24.5607C24.842 24.2794 25 23.8978 25 23.5V8.5C25 8.10218 24.842 7.72064 24.5607 7.43934C24.2794 7.15804 23.8978 7 23.5 7ZM21.0306 19.9694C21.1003 20.0391 21.1556 20.1218 21.1933 20.2128C21.231 20.3039 21.2504 20.4015 21.2504 20.5C21.2504 20.5985 21.231 20.6961 21.1933 20.7872C21.1556 20.8782 21.1003 20.9609 21.0306 21.0306C20.9609 21.1003 20.8782 21.1556 20.7872 21.1933C20.6961 21.231 20.5985 21.2504 20.5 21.2504C20.4015 21.2504 20.3039 21.231 20.2128 21.1933C20.1218 21.1556 20.0391 21.1003 19.9694 21.0306L16 17.0603L12.0306 21.0306C11.8899 21.1714 11.699 21.2504 11.5 21.2504C11.301 21.2504 11.1101 21.1714 10.9694 21.0306C10.8286 20.8899 10.7496 20.699 10.7496 20.5C10.7496 20.301 10.8286 20.1101 10.9694 19.9694L14.9397 16L10.9694 12.0306C10.8286 11.8899 10.7496 11.699 10.7496 11.5C10.7496 11.301 10.8286 11.1101 10.9694 10.9694C11.1101 10.8286 11.301 10.7496 11.5 10.7496C11.699 10.7496 11.8899 10.8286 12.0306 10.9694L16 14.9397L19.9694 10.9694C20.1101 10.8286 20.301 10.7496 20.5 10.7496C20.699 10.7496 20.8899 10.8286 21.0306 10.9694C21.1714 11.1101 21.2504 11.301 21.2504 11.5C21.2504 11.699 21.1714 11.8899 21.0306 12.0306L17.0603 16L21.0306 19.9694Z"
        fill="white"
      />
    </svg>
  );
};
const YoutubeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M24.7845 11.3507C24.6855 10.9552 24.4839 10.5928 24.2 10.3002C23.9161 10.0075 23.5601 9.79497 23.1678 9.68398C21.7345 9.33398 16.0011 9.33398 16.0011 9.33398C16.0011 9.33398 10.2678 9.33398 8.83446 9.71732C8.44217 9.8283 8.08611 10.0409 7.80225 10.3335C7.51839 10.6261 7.31678 10.9885 7.21779 11.384C6.95547 12.8386 6.82716 14.3142 6.83446 15.7923C6.82511 17.2815 6.95343 18.7684 7.21779 20.234C7.32693 20.6172 7.53305 20.9658 7.81625 21.246C8.09945 21.5263 8.45014 21.7288 8.83446 21.834C10.2678 22.2173 16.0011 22.2173 16.0011 22.2173C16.0011 22.2173 21.7345 22.2173 23.1678 21.834C23.5601 21.723 23.9161 21.5104 24.2 21.2178C24.4839 20.9252 24.6855 20.5628 24.7845 20.1673C25.0448 18.7236 25.1731 17.2593 25.1678 15.7923C25.1771 14.3031 25.0488 12.8162 24.7845 11.3507Z"
        fill="white"
      />
      <path
        d="M14.125 18.5164L18.9167 15.7914L14.125 13.0664V18.5164Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const TikTokIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M20.0578 10.5067C19.4503 9.81291 19.1155 8.92213 19.1156 8H16.3689V19.0222C16.3481 19.6188 16.0965 20.1841 15.6669 20.5987C15.2374 21.0133 14.6636 21.2448 14.0667 21.2444C12.8044 21.2444 11.7556 20.2133 11.7556 18.9333C11.7556 17.4044 13.2311 16.2578 14.7511 16.7289V13.92C11.6844 13.5111 9 15.8933 9 18.9333C9 21.8933 11.4533 24 14.0578 24C16.8489 24 19.1156 21.7333 19.1156 18.9333V13.3422C20.2293 14.1421 21.5665 14.5712 22.9378 14.5689V11.8222C22.9378 11.8222 21.2667 11.9022 20.0578 10.5067Z"
        fill="white"
      />
    </svg>
  );
};

const icons = {
  facebook: <FacebookIcon />,
  instagram: <InstagramIcon />,
  linkedin: <LinkedinIcon />,
  x: <TwitterIcon />, // Twitter is now "X"
  youtube: <YoutubeIcon />,
  tiktok: <TikTokIcon />,
};
const Footer2 = () => {
  const { data } = useFetchCompanyInfo();
  const { socialMediaLinks } = useFetchValidSocialMediaLinks(icons);

 
  const alteredLinks = usePagesWithBranchQuery();
  return (
    <footer
      
      id="footer"
      className=" text-white max-w-full overflow-clip"
    >
      <div
        style={{
          backgroundImage: `linear-gradient(180.79deg, rgba(var(--primary-color-rgb), 0.3) 12.91%, rgba(var(--primary-color-rgb), 0.3) 41.45%, rgba(var(--primary-color-rgb), 0.3) 58.98%), url('/images/footer-image-2.webp')`,
          backgroundSize: "cover",
        }}
        className="id"
      >
        <div className="first wrapper lg:flex-col py-14 pb-20 flex md:gap-10 gap-[7%]">
          <div className="first w-max h-max ">
            <CompanyLogo />
          </div>
          <div className="second flex xlg:flex-wrap flex-1 flex-col gap-14">
            <div className="addy-contact-email md:flex-col gap-8 flex justify-between">
              {/* addresss */}
              {data?.companyInfo?.head_office_address && (
                <div className="address">
                  <SmallHeader>Address</SmallHeader>

                  <IconFlex icon={<LocationIcon />}>
                    <Link
                      target={"_blank"}
                      className="hover:underline max-w-[250px]"
                      href={`https://maps.google.com/?q=${encodeURIComponent(
                        data?.companyInfo?.head_office_address
                      )}`}
                    >
                      {" "}
                      {data?.companyInfo?.head_office_address}
                    </Link>
                  </IconFlex>
                </div>
              )}

              {/* addresss */}
              {Array.isArray(data?.companyInfo?.phone_number) && (
                <div className="contact">
                  <SmallHeader>Contact</SmallHeader>
                  <IconFlex icon={<CallIcon />}>
                    <div className="grid grid-cols-2 gap-4">
                      {Array.isArray(data?.companyInfo?.phone_number) &&
                      data.companyInfo.phone_number.length > 0 ? (
                        data.companyInfo.phone_number.map((item, index) => (
                          <Link
                            key={index}
                            href={`tel:${item}`}
                            className="hover:underline"
                            aria-label={`Call ${item}`}
                          >
                            {item}
                          </Link>
                        ))
                      ) : (
                        <p className="col-span-2">No phone numbers available</p>
                      )}
                    </div>
                  </IconFlex>
                </div>
              )}

              {/* addresss */}
              {data?.companyInfo?.email && (
                <div className="email address">
                  <SmallHeader>Email</SmallHeader>
                  <IconFlex icon={<MessageIcon />}>
                    <Link
                      className="hover:underline"
                      href={`mailto:${data?.companyInfo?.email}`}
                    >
                      {data?.companyInfo?.email}
                    </Link>
                  </IconFlex>
                </div>
              )}
            </div>
            <div className="product-pages flex md:flex-col justify-between gap-8">
              <div className="product flex gap-4 flex-col">
                <BigHeader>Products</BigHeader>
                <div className="grid gap-2 grid-cols-2">
                  {FOOTER_NAV_LINKS.map((item, index) => {
                    return (
                      <ItemLink
                        className={getPageVisibilityClass(
                          item.url,
                          data as Config
                        )}
                        key={index}
                        href={item.url}
                      >
                        <span> {item.name}</span>
                      </ItemLink>
                    );
                  })}
                </div>
              </div>
              <div className="pages flex flex-col gap-4">
                <BigHeader>Pages</BigHeader>
                <div className="grid gap-2 grid-cols-2">
                  {alteredLinks.map((item, index) => {
                    return (
                      <ItemLink
                        className={getPageVisibilityClass(
                          item.url,
                          data as Config
                        )}
                        key={index}
                        href={item.url}
                      >
                        {item.name}
                      </ItemLink>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="second text-themeColor items-center py-3 flex md:flex-col md:gap-5 justify-between wrapper z-[10] bg-white">
        <div className="second items-center flex gap-2">
          {socialMediaLinks?.map((item, index) => {
            return (
              <Link className="scale-[1.05]" href={item.url} key={index}>
                {item.icon}
              </Link>
            );
          })}
        </div>
        <p
          className="truncate overflow-hidden whitespace-nowrap mx-4 md:mx-auto  xs:max-w-full "
          title={`${data?.companyInfo?.name}. All Rights Reserved.`}
        >
          © {data?.companyInfo?.name}. All Rights Reserved.
        </p>
        {data?.websiteSettings?.sponsored_logo && (
          <Link
            target={"_blank"}
            href="https://ourproperty.com.ng/"
            className="p flex items-center text-[12px]"
          >
            <span className="inline-block text-[13px] italic mr-2">
              Powered By:
            </span>
            <LogoVariant />
            <div className="font-bold ml-1">Our Property NG</div>
          </Link>
        )}
      </div>
    </footer>
  );
};
export default Footer2;

const ArrowIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1265_182798)">
        <path
          d="M11.9996 0.827117C12.1191 0.895588 12.2157 0.997777 12.2774 1.12089C12.3391 1.24401 12.3631 1.38259 12.3464 1.51928L11.2886 12.8715C11.2209 13.4226 10.5691 13.6795 10.1438 13.3225L8.15368 11.6523L7.15268 13.3862C6.577 14.3832 5.42088 14.488 4.42408 13.9124C3.42686 13.3367 2.93966 12.2832 3.51534 11.2862L4.51284 9.55849L2.10988 8.6842C1.5881 8.49422 1.48464 7.8015 1.92816 7.46732L11.2306 0.874997C11.34 0.792661 11.4712 0.744239 11.6079 0.735728C11.7446 0.727218 11.8808 0.758992 11.9996 0.827117ZM10.7567 2.98424L3.8008 7.80962L6.56062 8.81384L6.54774 8.83386L4.72774 11.9862C4.52782 12.3325 4.77758 12.5 5.12394 12.7C5.4703 12.8999 5.74022 13.0325 5.94014 12.6862L7.76014 9.53386L7.77456 9.50613L10.0557 11.4209L10.7567 2.98424Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1265_182798">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="matrix(-1 0 0 1 14 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// const Logo = () => {
//   return (
//     <svg
//       width="150"
//       height="50"
//       viewBox="0 0 150 50"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <rect width="150" height="50" rx="8" fill="white" />
//       <rect
//         x="16"
//         y="24.8281"
//         width="20.9704"
//         height="20.9704"
//         transform="rotate(-45 16 24.8281)"
//         fill="var(--primary-color)"
//       />
//       <path
//         d="M51.7502 18.6272H54.2464L57.2311 24.0247H57.3502L60.3349 18.6272H62.8311L58.3928 26.2766V30.8281H56.1885V26.2766L51.7502 18.6272ZM66.5888 31.0069C65.6952 31.0069 64.9207 30.8103 64.2654 30.4171C63.6101 30.0239 63.1017 29.4738 62.7403 28.7668C62.3828 28.0599 62.2041 27.2338 62.2041 26.2885C62.2041 25.3432 62.3828 24.5152 62.7403 23.8042C63.1017 23.0933 63.6101 22.5412 64.2654 22.148C64.9207 21.7548 65.6952 21.5582 66.5888 21.5582C67.4824 21.5582 68.2569 21.7548 68.9122 22.148C69.5676 22.5412 70.074 23.0933 70.4314 23.8042C70.7928 24.5152 70.9735 25.3432 70.9735 26.2885C70.9735 27.2338 70.7928 28.0599 70.4314 28.7668C70.074 29.4738 69.5676 30.0239 68.9122 30.4171C68.2569 30.8103 67.4824 31.0069 66.5888 31.0069ZM66.6007 29.2792C67.0853 29.2792 67.4904 29.1461 67.8161 28.88C68.1417 28.6099 68.384 28.2485 68.5429 27.7958C68.7057 27.343 68.7871 26.8386 68.7871 26.2825C68.7871 25.7225 68.7057 25.2162 68.5429 24.7634C68.384 24.3066 68.1417 23.9432 67.8161 23.6732C67.4904 23.4031 67.0853 23.2681 66.6007 23.2681C66.1043 23.2681 65.6912 23.4031 65.3616 23.6732C65.0359 23.9432 64.7916 24.3066 64.6288 24.7634C64.4699 25.2162 64.3905 25.7225 64.3905 26.2825C64.3905 26.8386 64.4699 27.343 64.6288 27.7958C64.7916 28.2485 65.0359 28.6099 65.3616 28.88C65.6912 29.1461 66.1043 29.2792 66.6007 29.2792ZM78.6364 26.9796V21.6774H80.793V30.8281H78.7019V29.2017H78.6066C78.4001 29.7141 78.0605 30.1331 77.5879 30.4588C77.1192 30.7844 76.5413 30.9473 75.8542 30.9473C75.2545 30.9473 74.7243 30.8142 74.2636 30.5481C73.8068 30.278 73.4494 29.8868 73.1912 29.3745C72.9331 28.8582 72.804 28.2346 72.804 27.5038V21.6774H74.9606V27.1702C74.9606 27.7501 75.1195 28.2108 75.4372 28.5524C75.7549 28.8939 76.172 29.0647 76.6883 29.0647C77.006 29.0647 77.3138 28.9873 77.6117 28.8324C77.9096 28.6775 78.1538 28.4471 78.3445 28.1413C78.5391 27.8315 78.6364 27.4443 78.6364 26.9796ZM83.0107 30.8281V21.6774H85.1018V23.2025H85.1971C85.3639 22.6743 85.6499 22.2672 86.055 21.9812C86.464 21.6913 86.9307 21.5463 87.455 21.5463C87.5741 21.5463 87.7072 21.5523 87.8541 21.5642C88.0051 21.5721 88.1302 21.5861 88.2295 21.6059V23.5898C88.1381 23.558 87.9931 23.5302 87.7946 23.5064C87.5999 23.4786 87.4113 23.4646 87.2286 23.4646C86.8354 23.4646 86.4819 23.55 86.1682 23.7208C85.8584 23.8876 85.6141 24.12 85.4354 24.4179C85.2567 24.7157 85.1673 25.0593 85.1673 25.4485V30.8281H83.0107ZM93.9189 30.8281V18.6272H96.1291V28.9753H101.503V30.8281H93.9189ZM107.317 31.0069C106.424 31.0069 105.649 30.8103 104.994 30.4171C104.339 30.0239 103.83 29.4738 103.469 28.7668C103.111 28.0599 102.933 27.2338 102.933 26.2885C102.933 25.3432 103.111 24.5152 103.469 23.8042C103.83 23.0933 104.339 22.5412 104.994 22.148C105.649 21.7548 106.424 21.5582 107.317 21.5582C108.211 21.5582 108.985 21.7548 109.641 22.148C110.296 22.5412 110.802 23.0933 111.16 23.8042C111.521 24.5152 111.702 25.3432 111.702 26.2885C111.702 27.2338 111.521 28.0599 111.16 28.7668C110.802 29.4738 110.296 30.0239 109.641 30.4171C108.985 30.8103 108.211 31.0069 107.317 31.0069ZM107.329 29.2792C107.814 29.2792 108.219 29.1461 108.545 28.88C108.87 28.6099 109.112 28.2485 109.271 27.7958C109.434 27.343 109.516 26.8386 109.516 26.2825C109.516 25.7225 109.434 25.2162 109.271 24.7634C109.112 24.3066 108.87 23.9432 108.545 23.6732C108.219 23.4031 107.814 23.2681 107.329 23.2681C106.833 23.2681 106.42 23.4031 106.09 23.6732C105.764 23.9432 105.52 24.3066 105.357 24.7634C105.198 25.2162 105.119 25.7225 105.119 26.2825C105.119 26.8386 105.198 27.343 105.357 27.7958C105.52 28.2485 105.764 28.6099 106.09 28.88C106.42 29.1461 106.833 29.2792 107.329 29.2792ZM117.512 34.4503C116.738 34.4503 116.072 34.345 115.516 34.1345C114.96 33.928 114.513 33.65 114.176 33.3005C113.838 32.951 113.604 32.5637 113.473 32.1388L115.415 31.6681C115.502 31.8469 115.63 32.0236 115.796 32.1984C115.963 32.3771 116.188 32.524 116.47 32.6392C116.755 32.7584 117.115 32.8179 117.548 32.8179C118.159 32.8179 118.666 32.669 119.067 32.3711C119.468 32.0772 119.669 31.5927 119.669 30.9175V29.1839H119.561C119.45 29.4063 119.287 29.6346 119.073 29.869C118.862 30.1033 118.582 30.2999 118.233 30.4588C117.887 30.6176 117.452 30.6971 116.928 30.6971C116.225 30.6971 115.588 30.5322 115.016 30.2026C114.448 29.869 113.995 29.3725 113.658 28.7132C113.324 28.0499 113.157 27.2199 113.157 26.223C113.157 25.2181 113.324 24.3702 113.658 23.6791C113.995 22.9841 114.45 22.4578 115.022 22.1004C115.594 21.739 116.231 21.5582 116.934 21.5582C117.47 21.5582 117.911 21.6496 118.257 21.8323C118.606 22.011 118.884 22.2275 119.091 22.4817C119.297 22.7319 119.454 22.9682 119.561 23.1906H119.681V21.6774H121.807V30.9771C121.807 31.7595 121.621 32.4069 121.247 32.9192C120.874 33.4316 120.364 33.8148 119.716 34.069C119.069 34.3232 118.334 34.4503 117.512 34.4503ZM117.53 29.0051C117.987 29.0051 118.376 28.8939 118.698 28.6715C119.019 28.4491 119.264 28.1294 119.43 27.7124C119.597 27.2953 119.681 26.7949 119.681 26.2111C119.681 25.6352 119.597 25.1308 119.43 24.6979C119.268 24.2649 119.025 23.9293 118.704 23.691C118.386 23.4488 117.995 23.3276 117.53 23.3276C117.049 23.3276 116.648 23.4527 116.327 23.7029C116.005 23.9532 115.763 24.2967 115.6 24.7336C115.437 25.1665 115.355 25.659 115.355 26.2111C115.355 26.7711 115.437 27.2616 115.6 27.6826C115.767 28.0996 116.011 28.4253 116.332 28.6596C116.658 28.89 117.057 29.0051 117.53 29.0051ZM128.009 31.0069C127.116 31.0069 126.341 30.8103 125.686 30.4171C125.03 30.0239 124.522 29.4738 124.161 28.7668C123.803 28.0599 123.624 27.2338 123.624 26.2885C123.624 25.3432 123.803 24.5152 124.161 23.8042C124.522 23.0933 125.03 22.5412 125.686 22.148C126.341 21.7548 127.116 21.5582 128.009 21.5582C128.903 21.5582 129.677 21.7548 130.333 22.148C130.988 22.5412 131.494 23.0933 131.852 23.8042C132.213 24.5152 132.394 25.3432 132.394 26.2885C132.394 27.2338 132.213 28.0599 131.852 28.7668C131.494 29.4738 130.988 30.0239 130.333 30.4171C129.677 30.8103 128.903 31.0069 128.009 31.0069ZM128.021 29.2792C128.506 29.2792 128.911 29.1461 129.236 28.88C129.562 28.6099 129.804 28.2485 129.963 27.7958C130.126 27.343 130.208 26.8386 130.208 26.2825C130.208 25.7225 130.126 25.2162 129.963 24.7634C129.804 24.3066 129.562 23.9432 129.236 23.6732C128.911 23.4031 128.506 23.2681 128.021 23.2681C127.525 23.2681 127.112 23.4031 126.782 23.6732C126.456 23.9432 126.212 24.3066 126.049 24.7634C125.89 25.2162 125.811 25.7225 125.811 26.2825C125.811 26.8386 125.89 27.343 126.049 27.7958C126.212 28.2485 126.456 28.6099 126.782 28.88C127.112 29.1461 127.525 29.2792 128.021 29.2792Z"
//         fill="var(--primary-color)"
//       />
//     </svg>
//   );
// };
const SmallHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <h6 className="font-semibold mb-4 text-xl">{children}</h6>;
};

const BigHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <h5 className="font-semibold text-[1.7rem]">{children}</h5>;
};

const ItemLink: React.FC<{
  href: string;
  children: React.ReactNode;
  className?: string;
}> = ({ href, children, className }) => {
  return (
    <Link className={`flex gap-2 items-center ${className}`} href={href}>
      <span>
        <ArrowIcon />
      </span>
      <div className="hover:underline  text-lg">{children}</div>
    </Link>
  );
};

const IconFlex: React.FC<{
  icon: React.ReactNode;
  children: React.ReactNode;
}> = ({ icon, children }) => {
  return (
    <div className="flex gap-2">
      <span className="block mt-1">{icon}</span>
      <div className="la capitalize">{children}</div>
    </div>
  );
};

const LocationIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 10.832C11.8807 10.832 13 9.71274 13 8.33203C13 6.95132 11.8807 5.83203 10.5 5.83203C9.11929 5.83203 8 6.95132 8 8.33203C8 9.71274 9.11929 10.832 10.5 10.832Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5007 1.66602C8.73254 1.66602 7.03685 2.36839 5.78661 3.61864C4.53636 4.86888 3.83398 6.56457 3.83398 8.33268C3.83398 9.90935 4.16898 10.941 5.08398 12.0827L10.5007 18.3327L15.9173 12.0827C16.8323 10.941 17.1673 9.90935 17.1673 8.33268C17.1673 6.56457 16.4649 4.86888 15.2147 3.61864C13.9645 2.36839 12.2688 1.66602 10.5007 1.66602Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const CallIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66732 2.5C7.08398 2.5 8.75065 6.25 8.75065 6.66667C8.75065 7.5 7.50065 8.33333 7.08398 9.16667C6.66732 10 7.50065 10.8333 8.33398 11.6667C8.65898 11.9917 10.0007 13.3333 10.834 12.9167C11.6673 12.5 12.5007 11.25 13.334 11.25C13.7507 11.25 17.5007 12.9167 17.5007 13.3333C17.5007 15 16.2507 16.25 15.0007 16.6667C13.7507 17.0833 12.9173 17.0833 11.2507 16.6667C9.58398 16.25 8.33398 15.8333 6.25065 13.75C4.16732 11.6667 3.75065 10.4167 3.33398 8.75C2.91732 7.08333 2.91732 6.25 3.33398 5C3.75065 3.75 5.00065 2.5 6.66732 2.5Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const MessageIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83333 7.49935L8.95833 9.99935C9.25394 10.236 9.62132 10.365 10 10.365C10.3787 10.365 10.7461 10.236 11.0417 9.99935L14.1667 7.49935M17.5 14.166V5.83268C17.5 5.39065 17.3244 4.96673 17.0118 4.65417C16.6993 4.34161 16.2754 4.16602 15.8333 4.16602H4.16667C3.72464 4.16602 3.30072 4.34161 2.98816 4.65417C2.67559 4.96673 2.5 5.39065 2.5 5.83268V14.166C2.5 14.608 2.67559 15.032 2.98816 15.3445C3.30072 15.6571 3.72464 15.8327 4.16667 15.8327H15.8333C16.2754 15.8327 16.6993 15.6571 17.0118 15.3445C17.3244 15.032 17.5 14.608 17.5 14.166Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
